// extracted by mini-css-extract-plugin
module.exports = {"start--btn":"styles_start--btn__3D_lr","btn--not-allowed":"styles_btn--not-allowed__3GixG","btn--slider":"styles_btn--slider__1KQlx","preview":"styles_preview__259oJ"};